import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import AntdDropdown from 'antd/lib/dropdown/dropdown';
var DropDown = /*#__PURE__*/React.memo(props => {
  return /*#__PURE__*/React.createElement(AntdDropdown, _extends({
    className: "sk-dropdown-iconbtn"
  }, props));
});
export default DropDown;